import {makeStyles} from "@material-ui/core";
import Fon from "./img/Fon.png";

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
        height: '100%',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'center',
        backgroundImage: `url(${Fon})`,
    },
    autocompleteWrapper: {
        padding: '8px',
        border: '3px solid red',
        borderRadius: '5px',
        marginTop: '8px',
    },
    error: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        textAlign: 'center',
        color: theme.palette.error.light,
        fontWeight: 600,
        padding: '8px'
    },
    setDateWrapper: {
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        padding: '8px',
        maxWidth: '900px',

        '@media (max-width: 900px)': {
            flexDirection: 'column',
            justifyContent: 'flex-start',
            padding: '0px',
            margin: '8px'
        },
    },
    month: {
        minWidth: '300px',
        height: '100px',
        padding: '8px',
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        fontSize: '2rem',
        cursor: 'pointer',
        transition: '.3s',
        backgroundColor: 'rgba(0, 0, 0, 0.05)',
        borderRadius: '5px',
        color: theme.palette.primary.main,

        '&:hover': {
            transition: '.3s',
            color: theme.palette.secondary.main,
            backgroundColor: 'rgba(0, 0, 0, 0.1)',
        },

        '@media (max-width: 900px)': {
            marginTop: '4px',
        },
    },
    selectedMonth: {
        boxShadow: '2px 0px 10px 0px #70707088',
        borderRadius: '10px',
        background: 'white',

        '@media (max-width: 900px)': {
            marginBottom: theme.spacing(2),
        },
    },
    monthHeading: {
        background: theme.palette.primary.dark,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        paddingLeft: theme.spacing(7.5),
        paddingRight: theme.spacing(5.5),
        paddingTop: '10px',
        paddingBottom: '10px',
        borderRadius: '10px 10px 0px 0px',
        height: '50px',
    },
    monthHeadingText: {
        fontSize: '16px',
        fontWeight: 600,
        textTransform: 'uppercase',
        lineHeight: '21px',
        color: 'white',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        margin: 0,

        '@media (max-width: 900px)': {
            fontSize: '14px',
        }
    },
    selectDay: {
        boxShadow: '2px 0px 10px 0px #70707088',
        borderRadius: '10px',
        background: 'white',
    },
    table: {
        tableLayout: 'fixed',
        maxWidth: '382px',
        textAlign: 'center',
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2),
        marginBottom: theme.spacing(2),
        borderCollapse:'separate',
        borderSpacing: '4px',

        '& tr': {
            height: '50px',

            '@media (max-width: 900px)': {
                height: '36px',
            },
        },

        '@media (max-width: 900px)': {
            margin: '0 auto',
            marginBottom: theme.spacing(2),
            maxWidth: '284px',
        }
    },
    tableDay: {
        tableLayout: 'fixed',
        maxWidth: '382px',
        textAlign: 'center',
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2),
        marginBottom: theme.spacing(2),
        borderCollapse:'separate',
        borderSpacing: '8px',

        '& tr': {
            height: '30px',

            '@media (max-width: 900px)': {
                height: '30px',
            },
        },

        '@media (max-width: 900px)': {
            margin: '0 auto',
            marginBottom: theme.spacing(2),
        }
    },
    tableHeadMonthName: {
        textAlign: 'center',
        border: 'none'
    },
    dayCell: {
        textAlign: 'center',
        transition: '.5s',
        cursor: 'pointer',
        background: theme.palette.secondary.main,
        fontWeight: 600,
        width: '50px',
        height: '50px',
        padding: 0,
        margin: '4px',
        borderRadius: '25px',
        border: 'none',

        '&:hover': {
            background: theme.palette.primary.lighter,
            transition: '.5s',
        },
        '@media (max-width: 900px)': {
            width: '36px',
            height: '36px',
            borderRadius: '18px',
        },
    },
    hourCell: {
        textAlign: 'center',
        transition: '.5s',
        cursor: 'pointer',
        background: theme.palette.secondary.main,
        fontWeight: 600,
        width: '50px',
        height: '30px',
        padding: 0,
        margin: '4px',
        borderRadius: '18px',

        '&:hover': {
            background: theme.palette.primary.lighter,
            transition: '.5s',
        },
        '@media (max-width: 900px)': {
            width: '50px',
            height: '30px',
            borderRadius: '18px',
        },
    },
    hourCellActive: {
        textAlign: 'center',
        transition: '.5s',
        cursor: 'default',
        background: theme.palette.primary.main,
        fontWeight: 600,
        width: '50px',
        height: '30px',
        padding: 0,
        margin: '4px',
        borderRadius: '18px',

        '@media (max-width: 900px)': {
            width: '50px',
            height: '30px',
            borderRadius: '18px',
        },
    },
    hourCellNotActive: {
        textAlign: 'center',
        transition: '.5s',
        cursor: 'default',
        background: 'rgba(0, 0, 0, 0.1)',
        fontWeight: 600,
        width: '50px',
        height: '30px',
        padding: 0,
        margin: '4px',
        borderRadius: '18px',
        border: 'none',

        '@media (max-width: 900px)': {
            width: '50px',
            height: '30px',
            borderRadius: '18px',
        },
    },
    dayCellActive: {
        textAlign: 'center',
        transition: '.5s',
        cursor: 'default',
        background: theme.palette.primary.main,
        fontWeight: 600,
        width: '50px',
        height: '50px',
        padding: 0,
        margin: '4px',
        borderRadius: '25px',
        border: 'none',

        '@media (max-width: 900px)': {
            width: '36px',
            height: '36px',
            borderRadius: '18px',
        },
    },
    dayCellLock: {
        textAlign: 'center',
        cursor: 'default',
        background: 'rgba(0, 0, 0, 0.1)',
        fontWeight: 600,
        width: '50px',
        height: '50px',
        padding: 0,
        margin: '4px',
        borderRadius: '25px',
        border: 'none',

        '@media (max-width: 900px)': {
            width: '36px',
            height: '36px',
            borderRadius: '18px',
        },
    },
    tableCell: {
        padding: '16px 10px',
        border: 'none'
    },
    actionButtonContainer: {
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        padding: '8px',
    },
    annotations: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
    },
    annotationsTableDesktop: {
        tableLayout: 'fixed',
        maxWidth: '900px',

        '@media (max-width: 900px)': {
            display: 'none',
        },
    },
    annotationsTableMobile: {
        tableLayout: 'fixed',
        display: 'none',

        '@media (max-width: 900px)': {
            display: 'table',
        },
    },
    actionButton: {
        maxWidth: '300px',
        width: 196,
        margin: '8px auto',
    },
    orderActionButton: {
        width: '196px',
        marginTop: '8px',

        '@media (max-width: 1140px)': {
            width: '95%',
            margin: '4px auto',
        },
    },
    tableCellBorderNone: {
        border: 'none',

        '@media (max-width: 900px)': {
            width: '36px',
            height: '36px',
            padding: theme.spacing(1)
        },
    },
}));

export default useStyles;
